import { render } from "./Home.vue?vue&type=template&id=4aa2fcd4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4aa2fcd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4aa2fcd4"

export default script